import { render, staticRenderFns } from "./WaterMetric.vue?vue&type=template&id=13fe68cf&scoped=true&"
import script from "./WaterMetric.vue?vue&type=script&lang=js&"
export * from "./WaterMetric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe68cf",
  null
  
)

export default component.exports